import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
// @mui
import { Alert, IconButton, InputAdornment, Link, Stack } from '@mui/material';
// next
import NextLink from 'next/link';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
// form
import { useForm } from 'react-hook-form';
import { FormProvider, RHFCheckbox, RHFTextField } from 'src/components/hook-form';
// components
import Iconify from 'src/components/Iconify';
// hooks
import useAuth from 'src/hooks/commonUseAuth';
// routes
import { PATH_AUTH } from 'src/routes/paths';
import * as Yup from 'yup';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const { login, employeeLogin } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string().required('Email is required'),
    password: Yup.string().required('Password is required'),
  });

  const defaultValues = {
    email: '',
    password: '',
    remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    try {
      await login(data.email, data.password, enqueueSnackbar);
      reset();
    } catch (error) {
      const { response } = error;

      if (response) {
        // show error message
        // enqueueSnackbar(response.data.message, {
        //   variant: 'error',
        // });
      
        try{
          await employeeLogin(data.email, data.password, enqueueSnackbar);
          reset();
        }catch(err) {
          const { response } = err;
          // show error message
          enqueueSnackbar(response.data.message, {
            variant: 'error',
          });
        }
        

        // set server error 
        if (response.status === 422) {
          // eslint-disable-next-line no-unused-vars
          for (const [key, value] of Object.entries(data)) {
            if (response.data.errors[key]) {
              setError(key, {
                type: "manual",
                message: response.data.errors[key][0],
              });
            }
          }
        }
      }

    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

        <RHFTextField name="email" label="Email address" />

        <RHFTextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        <RHFCheckbox name="remember" label="Remember me" />
        <NextLink href={PATH_AUTH.resetPassword} passHref>
          <Link variant="subtitle2">Forgot password?</Link>
        </NextLink>
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
        Login
      </LoadingButton>
    </FormProvider>
  );
}
